module.exports = __webpack_public_path__ + "img/165.2dd00279.jpg";